import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Typography from '@material-ui/core/Typography'
import { injectIntl } from 'react-intl'
import SurveyResponseTabs from './SurveyResponseTabs'
import { Container, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	titleRoot: {
		color: 'white',
		marginTop: '5rem',
		marginBottom: '2rem',
		textAlign: 'center',
	},
	textRoot: {
		color: 'white',
		padding: '32px 0 8px',
		textAlign: 'center',
		fontSize: '1.1em',
		maxWidth: '92rem',
		textShadow: '0 1px 1px #000',
	},
}))

const SurveyResponseContainer = ({ intl, schema }) => {
	const classes = useStyles()

	return (
		<div>
			<Container data-testid="survey-response-container" maxWidth="lg">
				<Grid container alignItems="center" justify="center" >
					<Grid item xs={12}>
						<Typography data-testid="survey-response-container-title" variant='h4' className={classes.titleRoot}>
							{intl.formatMessage({ id: 'app.dashboard.sampleResults' })}
						</Typography>
					</Grid>
					<Grid item xs={12}>
						{schema && <SurveyResponseTabs data-testid="survey-response-tabs" schema={schema} />}
					</Grid>
				</Grid>
			</Container>
		</div>
	)
}

export default injectIntl(SurveyResponseContainer)
